var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    _c("div", { staticClass: "search pb-5" }, [
      _c("section", { staticClass: "container-fluid pb-sm-5" }, [
        _c("h1", { staticClass: "page-title" }, [_vm._v("Pesquisa")]),
        _vm._v(" "),
        _c("h2", { staticClass: "search__title py-3 py-md-4" }, [
          _c("strong", [_vm._v(_vm._s(_vm.results.length))]),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.resultText))]),
          _vm._v(" "),
          _c("span", [_vm._v("sobre “" + _vm._s(_vm.searchTerm) + "”")]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "container-fluid pb-0" },
        _vm._l(_vm.results, function (item, index) {
          return _c("search-item", { key: index, attrs: { item: item } })
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }